"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.evaluateExpression = exports.evaluate = exports.getEvaluator = void 0;
var parse_1 = require("../parse/parse");
var types_1 = require("../types");
var const_1 = require("./const");
var utils_1 = require("./utils");
var getEvaluator = function (expression) {
    var parsedExpression = (0, parse_1.parse)(expression);
    return function (booleanMap) { return (0, exports.evaluate)(parsedExpression, booleanMap); };
};
exports.getEvaluator = getEvaluator;
var evaluate = function (expression, booleanMap) {
    if (!Array.isArray(expression)) {
        throw new Error("".concat(expression, " should be an array. evaluate takes in a parsed expression. Use in combination with parse or use getEvaluator"));
    }
    // Resolves each identifier and adds it to a stack
    // When operator is found it operates on the top value(s)
    // on the stack, removes them and replaces them with the
    // result
    var evaluatedExpression = expression.reduce(function (stack, token, i) {
        if (!(token && ((0, utils_1.isIdentifier)(token) || (0, utils_1.isOperator)(token)))) {
            throw new Error("Invalid token: ".concat(token, ". Found in parsed expression at index ").concat(i));
        }
        if (token.name === types_1.Tokens.IDENTIFIER) {
            return __spreadArray(__spreadArray([], stack, true), [Boolean(booleanMap[token.value])], false);
        }
        var secondLastItem = stack[stack.length - 2];
        var lastItem = stack[stack.length - 1];
        if (token.value === types_1.Operators.NOT) {
            if (lastItem === undefined) {
                (0, utils_1.throwInvalidExpression)('missing identifier');
            }
            return __spreadArray(__spreadArray([], stack.slice(0, -1), true), [(0, utils_1.notUtil)(lastItem)], false);
        }
        if (lastItem === undefined || secondLastItem === undefined) {
            (0, utils_1.throwInvalidExpression)('missing identifier');
        }
        var operatorUtil = const_1.OPERATOR_MAP[token.value];
        if (!operatorUtil) {
            (0, utils_1.throwInvalidExpression)('unknown operator');
        }
        return __spreadArray(__spreadArray([], stack.slice(0, -2), true), [operatorUtil(secondLastItem, lastItem)], false);
    }, []);
    if (evaluatedExpression.length !== 1) {
        (0, utils_1.throwInvalidExpression)('too many identifiers after evaluation');
    }
    return evaluatedExpression[0];
};
exports.evaluate = evaluate;
var evaluateExpression = function (expression, booleanMap) { return (0, exports.getEvaluator)(expression)(booleanMap); };
exports.evaluateExpression = evaluateExpression;
